<template>
  <div class="footer">
    <div class="footer-column-a">
      <div class="a-left">
        <div class="f-row-info">
          <div class="footer_logo">
            <img src="../../assets/img/common/logo_bottom.png" alt="logo" />
          </div>
          <div class="footer_phone">
            <i class="icon_phone"></i>
          </div>
          <div class="footer_address">广州市越秀区文德路67号金德大厦9楼</div>
        </div>
        <div class="f_row-link">
          <span>友情链接：</span>
          <div class="link_ul">
            <a
              target="_blank"
              href="http://www.stats.gov.cn/"
              title="国家统计局"
              >国家统计局</a
            >
            <a
              target="_blank"
              href="http://stats.gd.gov.cn/"
              title="广东省统计局"
              >广东省统计局
            </a>
            <a target="_blank" href="http://tjj.gz.gov.cn/" title="广州市统计局"
              >广州市统计局
            </a>
            <a
              target="_blank"
              href="http://www.giihg.com/"
              title="广州工业投资控股集团有限公司"
              >广州工业投资控股集团有限公司</a
            >
            <a
              target="_blank"
              href="https://www.gcec.com.cn/"
              title="广州化工交易中心有限公司"
              >广州化工交易中心有限公司
            </a>
            <a target="_blank" href="https://www.hg1.com.cn/" title="化工易平台"
              >化工易平台
            </a>
          </div>
        </div>
      </div>
      <div class="footer_qrcode">
        <img src="../../assets/img/common/qrcode.png" alt="qrcode" />
      </div>
    </div>
    <div class="footer-column-b">
      <a
        class="fbeian_link"
        target="_blank"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        title="粤ICP备08015174号"
      >
        广州统计师事务所版权所有 ICP号：粤ICP备2021178782号-1
        技术支持：广州化工交易中心有限公司
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "ComFooter",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
.footer {
  width: 100%;
  min-height: 236px;
  background-color: $themeColor;
  position: relative;
  .footer-column-a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1180px;
    margin: 0 auto;
    padding: 20px 0 30px 0;

    .a-left {
      width: 1100px;
      .f-row-info {
        display: flex;
        align-items: center;

        .footer_logo {
          display: flex;
          align-items: center;
          margin-right: 30px;
          img {
            display: block;
            width: 170x;
            height: 28px;
            object-fit: cover;
          }
        }
        .footer_phone {
          display: flex;
          align-items: center;
          position: relative;
          margin-right: 30px;
          .icon_phone {
            display: inline-block;
            width: 200px;
            height: 26px;
            background: url("../../assets/img/common/phone.png") no-repeat;
            background-size: cover;
          }
        }
        .footer_address {
          font-size: 16px;
          color: #ffffff;
        }
      }
      .f_row-link {
        display: flex;
        font-size: 16px;
        color: #ffffff;
        padding: 30px 0 0 0;
        height: 30px;
        line-height: 30px;
        .link_ul {
          display: inline-block;
          width: 960px;
        }
        a {
          height: 30px;
          line-height: 30px;
          display: inline-block;
          padding: 0 0 0 20px;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    // .footer_qrcode {
    // }
  }
  .footer-column-b {
    width: 1180px;
    margin: 0 auto;
    padding: 30px 0 0 0;
    border-top: 1px solid #527ae0;
    .fbeian_link {
      width: 100%;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
    }
  }
}
</style>
